import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { ComparisonState } from '../comparison-state';
import { reducer as comparisonReducer, initialState as initialComparisonState } from './comparison.reducer';

export const initialState: ComparisonState = initialComparisonState;

export function getReducers(): ActionReducerMap<typeof comparisonReducer> {
  return comparisonReducer;
}

export const reducerToken: InjectionToken<ActionReducerMap<ComparisonState>> = new InjectionToken<
  ActionReducerMap<ComparisonState>
>('ComparisonReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
